// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"a748f36a","411":"a748f36a","451":"5286a770","570":"5286a770","640":"5286a770"}[chunkId] + ".chunk.css";
};